import React, { useState } from "react";
import {
  Button,
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  useDisclosure,
  Chip,
} from "@nextui-org/react";
import { FaEye, FaCode } from "react-icons/fa";
import EnhancedPreviewForm from "./EnhancedPreviewForm";
import { getJSonSchemaFromFieldInfoList } from "../../utils/frombuilder.utils";

const QuickPreviewModal = ({ fieldInfoList, formData = {} }) => {
  const { isOpen, onOpen, onOpenChange } = useDisclosure();


  // Generate preview data from fieldInfoList
  const generatePreviewData = () => {
    if (!fieldInfoList || fieldInfoList.length === 0) {
      return {
        Name: "Form Preview",
        JsonSchema: {
          properties: {},
          required: []
        }
      };
    }

    const jsonSchema = getJSonSchemaFromFieldInfoList(fieldInfoList, []);
    
    return {
      Name: formData.metricName || "Form Preview",
      description: formData.description || "Preview of your form as users will see it",
      JsonSchema: jsonSchema
    };
  };

  const previewData = generatePreviewData();



  return (
    <>
      <Button
        size="sm"
        variant="bordered"
        onPress={onOpen}
        startContent={<FaEye />}
        className="ml-2 border-slate-300 hover:border-slate-400 px-6 font-medium"
      >
        Quick Preview
      </Button>

      <Modal
        isOpen={isOpen}
        onOpenChange={onOpenChange}
        size="5xl"
        scrollBehavior="inside"
        classNames={{
          base: "bg-white border border-slate-200 shadow-lg",
          header: "border-b border-slate-200 bg-slate-50",
          body: "py-6",
          footer: "border-t border-slate-200 bg-slate-50",
        }}
      >
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex flex-col gap-2 px-6 py-4">
                <div className="flex items-center justify-between w-full">
                  <div>
                    <h3 className="text-lg font-semibold text-slate-900">Form Preview</h3>
                    <p className="text-sm text-slate-600 mt-1">This is how your form will appear to users</p>
                  </div>
                  <div className="flex items-center gap-2">
                    <Chip color="success" variant="flat" size="sm" startContent={<FaEye />}>
                      Live Preview
                    </Chip>
                    <Button
                      size="sm"
                      variant="bordered"
                      startContent={<FaCode />}
                      className="border-slate-300 hover:border-slate-400"
                    >
                      View Data
                    </Button>
                  </div>
                </div>
                

              </ModalHeader>
              <ModalBody className="px-6">
                <div className="max-w-4xl mx-auto">
                  {fieldInfoList && fieldInfoList.length > 0 ? (
                    <EnhancedPreviewForm 
                      data={previewData} 
                      fieldInfoList={fieldInfoList}
                    />
                  ) : (
                    <div className="text-center py-12 text-slate-500">
                      <FaEye className="mx-auto text-4xl mb-4 opacity-50" />
                      <h4 className="text-lg font-medium mb-2">No Preview Available</h4>
                      <p className="text-sm">Add some fields to your form to see the preview</p>
                    </div>
                  )}
                </div>
              </ModalBody>
              <ModalFooter className="px-6 py-4">
                <div className="flex gap-3 justify-end w-full">
                  <Button
                    color="primary"
                    onPress={onClose}
                    variant="bordered"
                    className="px-6 border-slate-300 hover:border-slate-400"
                  >
                    Close Preview
                  </Button>
                </div>
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
};

export default QuickPreviewModal;